/* Source LED palette — where a fare came from, conveyed by a small glowing
   colored dot. Color is NEVER the sole signal: the dot always carries a
   title/aria-label, and the "Where each fare comes from" legend spells every
   color out (WCAG AA). Open-class: unknown sources fall back to db/grey. */

export interface SourceMeta {
  /** Solid dot color (hex). */
  color: string;
  /** Default human label (the backend usually supplies its own `label`). */
  label: string;
}

export const SOURCE_META: Record<string, SourceMeta> = {
  airline: { color: "#16a34a", label: "Airline direct" }, // green
  google: { color: "#4285f4", label: "via Google" }, // blue
  gds: { color: "#f59e0b", label: "GDS" }, // amber
  ndc: { color: "#8b5cf6", label: "NDC" }, // violet
  db: { color: "#A5A29A", label: "Cached" }, // warm grey
};

/** Look up palette for a source key, falling back to db/grey for unknowns. */
export function sourceMeta(source: string | null | undefined): SourceMeta {
  if (source && SOURCE_META[source]) return SOURCE_META[source];
  return SOURCE_META.db;
}
